/**
 * @file
 * markerList object built from png markers. Used for custom leaflet icons in
 * BasstrakkMap.
 */
// Boat markers
import boat_1Png from './markers/png/boat_1.png';
import boat_10Png from './markers/png/boat_10.png';
import boat_11Png from './markers/png/boat_11.png';
import boat_12Png from './markers/png/boat_12.png';
import boat_2Png from './markers/png/boat_2.png';
import boat_3Png from './markers/png/boat_3.png';
import boat_4Png from './markers/png/boat_4.png';
import boat_5Png from './markers/png/boat_5.png';
import boat_6Png from './markers/png/boat_6.png';
import boat_7Png from './markers/png/boat_7.png';
import boat_8Png from './markers/png/boat_8.png';
import boat_9Png from './markers/png/boat_9.png';

// Fish markers
import fish_1Png from './markers/png/fish_1.png';
import fish_10Png from './markers/png/fish_10.png';
import fish_11Png from './markers/png/fish_11.png';
import fish_12Png from './markers/png/fish_12.png';
import fish_2Png from './markers/png/fish_2.png';
import fish_3Png from './markers/png/fish_3.png';
import fish_4Png from './markers/png/fish_4.png';
import fish_5Png from './markers/png/fish_5.png';
import fish_6Png from './markers/png/fish_6.png';
import fish_7Png from './markers/png/fish_7.png';
import fish_8Png from './markers/png/fish_8.png';
import fish_9Png from './markers/png/fish_9.png';

// Types
import { IMarkerList } from './types';

export const markerList: IMarkerList = {
  boat: {
    1: boat_1Png,
    2: boat_2Png,
    3: boat_3Png,
    4: boat_4Png,
    5: boat_5Png,
    6: boat_6Png,
    7: boat_7Png,
    8: boat_8Png,
    9: boat_9Png,
    10: boat_10Png,
    11: boat_11Png,
    12: boat_12Png,
  },
  fish: {
    1: fish_1Png,
    2: fish_2Png,
    3: fish_3Png,
    4: fish_4Png,
    5: fish_5Png,
    6: fish_6Png,
    7: fish_7Png,
    8: fish_8Png,
    9: fish_9Png,
    10: fish_10Png,
    11: fish_11Png,
    12: fish_12Png,
  },
};
